import { IAtMediaProps } from '@/components/atoms/at-media/at-media.types';
import { IOrVideoHeroCSProps } from '@/lib/contentstack-sdk/types';

// Separate file for enums to enable code splitting
export { EIcons } from '@/components/atoms/at-icon/icons';
export {
  EClickableSize,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
export { ESearchLocationFormVariants } from '@/components/molecules/ml-search-location-form/ml-search-location-form.types';

export interface IOrVideoHeroCsProps {
  block: IOrVideoHeroCSProps;
}

export interface IOrVideoHeroProps {
  description: string;
  image: IAtMediaProps;
  title: string;
  videoUrl: string;
}
